import { createAction } from '@reduxjs/toolkit';

import { errorPayloadCreator, getPayloadCreator } from '../core/actionHelpers';
import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';
import type { Filter, FilterProps } from './filtersTypes';

const syncFilterPayloadCreator = getPayloadCreator<QcsSyncResourcesPayload<FilterProps>>();
const filterPayloadCreator = getPayloadCreator<Filter>();

export const getFilters = createAction('GET_FILTERS', getPayloadCreator());
export const getFiltersSuccess = createAction('GET_FILTERS_SUCCESS', syncFilterPayloadCreator);
export const getFiltersFailure = createAction('GET_FILTERS_FAILURE', errorPayloadCreator);

export const createFilter = createAction('CREATE_FILTER', filterPayloadCreator);
export const createFilterSuccess = createAction('CREATE_FILTER_SUCCESS', filterPayloadCreator);
export const createFilterFailure = createAction('CREATE_FILTER_FAILURE', errorPayloadCreator);

export const updateFilter = createAction('UPDATE_FILTER', filterPayloadCreator);
export const updateFilterSuccess = createAction('UPDATE_FILTER_SUCCESS', filterPayloadCreator);
export const updateFilterFailure = createAction('UPDATE_FILTER_FAILURE', errorPayloadCreator);

export const deleteFilter = createAction('DELETE_FILTER', filterPayloadCreator);
export const deleteFilterSuccess = createAction('DELETE_FILTER_SUCCESS', filterPayloadCreator);
export const deleteFilterFailure = createAction('DELETE_FILTER_FAILURE', errorPayloadCreator);
